<template>
  <div>
    <el-table
      v-loading="loading"
      class="App-Admin-Table"
      size="medium"
      stripe
      :data="businesses"
      style="width: 100%"
    >
      <!--  -->
      <el-table-column align="center" label="#ID" width="60">
        <template #default="scope">
          <el-tooltip :content="scope.row._id">
            <i class="el-icon-office-building"></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <!--  -->
      <el-table-column prop="name" label="Name">
        <template #default="scope">
          {{ $filters.capitalize(scope.row.name) }}
        </template>
      </el-table-column>
      <!--  -->
      <el-table-column prop="stage" label="Stage" width="100">
        <template #default="scope">
          {{ $filters.capitalize(scope.row.stage) }}
        </template>
      </el-table-column>
      <!--  -->
      <!--  -->
      <el-table-column prop="businessModel" label="Model" width="130">
        <template #default="scope">
          <span>{{ $filters.capitalize(scope.row.businessModel) }}</span>
        </template>
      </el-table-column>
      <!--  -->
      <!-- Co Founders -->
      <el-table-column prop="industry" label="Industry" width="180">
        <template #default="scope">
          {{ $filters.capitalize(scope.row.industry) }} Industry
        </template>
      </el-table-column>
      <!--  -->
      <!-- Co Founders -->
      <el-table-column
        align="center"
        prop="coFoundersSize"
        label="Founders"
        width="100"
      >
        <template #default="scope">
          {{ scope.row.coFoundersSize + 1 }}
        </template>
      </el-table-column>
      <!--  -->
      <!-- Team Size -->
      <el-table-column align="center" prop="teamSize" label="Team" width="100">
        <template #default="scope">
          {{ scope.row.teamSize }}
        </template>
      </el-table-column>
      <!--  -->
      <!-- Team Size -->
      <el-table-column
        align="center"
        prop="funding"
        label="Funding"
        width="100"
      >
        <template #default="scope">
          <span
            v-if="
              typeof scope.row.funding === 'object' &&
              scope.row.funding !== null
            "
          >
            {{ scope.row.funding.currency }}
            {{ $filters.number(scope.row.funding.amount) }}
          </span>
          <span v-else>{{ scope.row.funding }}</span>
        </template>
      </el-table-column>
      <!--  -->
      <!--  -->
      <!--  -->
      <!-- Is Active -->
      <el-table-column align="center" label="Is Active" width="100">
        <template #default="scope">
          <el-switch :model-value="!scope.row.isArchived" size="mini" />
        </template>
      </el-table-column>
      <!--  -->
      <!-- Reset Score Email -->
      <el-table-column align="center" label="Reset Score" width="130">
        <template #default="scope">
          <el-tooltip content="Resets the survey score of this user.">
            <el-button
              icon="el-icon-refresh"
              is-borderless
              plain
              size="mini"
              @click="resetScore(scope.row._id)"
            >
              Reset
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
      <!--  -->
      <!-- Actions -->
      <!-- <el-table-column align="center" label="Actions" width="120">
        <template #default>
          <el-button
            icon="el-icon-more"
            is-borderless
            circle
            plain
            size="small"
          />
        </template>
      </el-table-column> -->
      <!--  -->
      <!--  -->
    </el-table>
  </div>
</template>

<script lang="ts">
import { Business, ErrorUtil, User } from "@/shared";
import { Options, Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Options({
  components: {},
})
export default class extends Vue {
  @Prop()
  businesses?: Array<Business>;

  @Prop({ type: Boolean })
  loading?: boolean;

  /**
   * @param business
   */
  resetScore(business: string) {
    return this.$api.admin
      .patch(`/v1/admin-businesses/${business}/score-reset`)
      .then(() => {
        this.$message({
          duration: ErrorUtil.duration,
          type: "success",
          message: "Survey score has been reset.",
        });
      })
      .catch((err) => {
        this.$message({
          duration: ErrorUtil.duration,
          type: "error",
          message: "Could not reset the score.",
        });
      });
  }
}
</script>

<style lang="scss">
.App-Admin-Table {
  &.el-table .el-table__body .cell {
    font-size: 12px;
  }
}
</style>
